var preloaderTime = 800;

$('.user-form__registration').submit(function(event) {
    event.preventDefault();
    var avatarValue = $('.avatar-input')[0].files.length;

    if (avatarValue == 0) {
        $('.load-avatar__text').addClass('has-error');
    }
})

$('.pop-up__user-form').submit(function() {
    var requestToDo = $(this).find('.user-pop-up__submit').data('request');

    validateFormFields($(this));

    if (validateStatus) {
        // $(this).find('.user-pop-up__submit').addClass('loading');

        if (requestToDo == 'registration') {
            registration($(this));
            return false;
        }
        else if (requestToDo == 'signin') {
            signin($(this));
            return false;
        }
        else if (requestToDo == 'password-recovery') {
            passwordRecovery($(this));
            return false;
        }
        else if (requestToDo == 'verify-phone') {
            var account_id = $('.verify-phone').data('account-id');
            verifyPhone($(this), account_id);
            showPopUp('new-password');
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
})

$('.rules-agree-form').submit(function() {
    acceptRules();
    return false;
})

$('body').on('click', '.js-resend-code', function() {
    var account_id = $('.verify-phone').data('account-id'),
        phone = $('.verify-phone').data('account-phone');

    getSmsCode(account_id, phone);
})

// загрузка аватара
$('.avatar-input').on('change', function() {
    loadAvatar();
})

$('body').on('click', '.select__option', function() {
    var id = $(this).data('id'),
        parentSelect = $(this).parent('.select__options-list');

    // запрос на школу
    if (parentSelect.hasClass('select__options-list_location')) {
        getSchool(id);
    }
    // запрос на класс
    else if (parentSelect.hasClass('select__options-list_school')) {
        getClasses(id);
    }
})

$('.select__options-list_classes').on('click', '.select__option', function() {
    var classId = $(this).data('id');
    $('.classes-input').data('id', classId);
})

// Регистрация
function registration(jqForm) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend,
        avatar = $('.avatar-input').data('avatar');

    trimFormFields(jqForm);

    var classId = $('.classes-input').data('id');
    $('.classes-input').attr('disabled', 'disabled');

    dataToSend = 'avatar=' + avatar + '&' + jqForm.serialize() + '&school_class=' + classId + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    $('.classes-input').removeAttr('disabled');

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/registration/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                showVerifyPopUp(responseObj.data.id, responseObj.data.phone);
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Вход
function signin(jqForm) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    trimFormFields(jqForm);
    var phoneWithMask = jqForm.find('input[type=tel]').val(),
        phoneWithoutMask = jqForm.find('input[type=tel]').val().replace(/[\s()+]/g, '');

    jqForm.find('input[type=tel]').val(phoneWithoutMask);
    dataToSend = jqForm.serialize() + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;
    jqForm.find('input[type=tel]').val(phoneWithMask);

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/signin/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                window.location.href = responseObj.data.url;
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Восстановление пароля
function passwordRecovery(jqForm) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend,
        phoneWithoutMask = jqForm.find('input[type=tel]').val().replace(/[\s()+]/g, ''),
        phoneWithMask = jqForm.find('input[type=tel]').val();

    dataToSend = 'phone=' + phoneWithoutMask + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/password-recovery/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                showPopUp('signin');
                $('.signin').find('input[type=tel]').val(phoneWithMask);
                $('.signin').find('input[type=password]').focus();
                if (responseObj.message) showNotification(responseObj.message, 'success');
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Подтверждение номера телефона
function verifyPhone(jqForm, account_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    trimFormFields(jqForm);
    dataToSend = jqForm.serialize() + '&id=' + account_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/confirm/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                window.location.href = responseObj.data.url;
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Повторный запрос sms кода
function getSmsCode(account_id, phone) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'id=' + account_id + '&phone=' + phone + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/get-sms-code/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                if (responseObj.message) showNotification(responseObj.message, 'success');
                startBackTimer();
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Загрзука аватара
function loadAvatar() {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend = new FormData();

    var file = $('.avatar-input')[0].files[0];
    dataToSend.append('csrfmiddlewaretoken', csrfmiddlewaretoken);
    dataToSend.append('file', file);

    $.ajax({
        data: dataToSend,
        url: '/api/site/uploads/',
        method: 'POST',
        processData: false,
        contentType: false,
        cache: false,

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.load-avatar__img').attr('src', responseObj.data.url).addClass('has-user-img');
                $('.avatar-input').data('avatar', responseObj.data.id);
                $('.load-avatar__text').removeClass('has-error').addClass('visible-hidden');
            }
            else {
                $('.load-avatar__text').addClass('has-error');
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Запрос школы
function getSchool(location_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'id=' + location_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/get-school/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.select__options-list_school').empty();
                $('.select__options-list_classes').empty();
                $('.school-input').val('').removeClass('disabled');
                $('.classes-input').val('');
                fillSelect($('.select__options-list_school'), responseObj.data.schools);
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Запрос класса
function getClasses(school_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'id=' + school_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/get-classes/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.select__options-list_classes').empty();
                $('.classes-input').val('').removeClass('disabled');
                fillSelect($('.select__options-list_classes'), responseObj.data.classes);
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Запрос на блок результатов
function getResult(stage_number, additional_data) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'number=' + stage_number + additional_data + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/get-result/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                if(responseObj.data.show_star) {
                    $('a[href*="#result"]').removeClass('btn-disabled').addClass('btn-new');
                }

                if ($('.result-wrap').parents('.loading').hasClass('visible')) {
                    setTimeout(function() {
                        $('.result-wrap').empty();
                        $('.result-wrap').append(responseObj.templates.result);
                        if (stage_number === '') {
                            stage_number = $('.js-stage-tab-btn.active').index() + 1;
                        }
                        drawRating($('.graph-canvas')[0], stage_number);
                    }, preloaderTime - 10);
                }
                else {
                    $('.result-wrap').empty();
                    $('.result-wrap').append(responseObj.templates.result);
                    if (stage_number === '') {
                        stage_number = $('.js-stage-tab-btn.active').index() + 1;
                    }
                    drawRating($('.graph-canvas')[0], stage_number);
                }
            }
        },
        complete: function() {
            setTimeout(function() {
                $('.result-wrap').parents('.loading').removeClass('visible');
            }, preloaderTime)
        }
    });
}

// Запрос на блок рейтинга
function getRating(stage_number, additional_data) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend
        selectedUserId = $('.rating__person_selected-user').data('user-id');

    dataToSend = 'number=' + stage_number + additional_data + '&selected_user=' + selectedUserId + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/get-rating/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                if(responseObj.data.show_star) {
                    $('a[href*="#rating"]').removeClass('btn-disabled').addClass('btn-new');
                }
                if ($('.rating-wrap').parents('.loading').hasClass('visible')) {
                    setTimeout(function () {
                        $('.rating-wrap').empty();
                        $('.rating-wrap').append(responseObj.templates.result);
                        $('.rating__person_selected-user').prev().addClass('rating__person_prev-selected-user');
                        if ($('.rating__person_selected-user').length === 1) {
                            $('.rating-table__tbody').stop().animate({
                                scrollTop: $('.rating__person_selected-user').position().top - 62
                            }, 1000);
                        }
                    }, preloaderTime - 10);
                }
                else {
                    $('.rating-wrap').empty();
                    $('.rating-wrap').append(responseObj.templates.result);
                    $('.rating__person_selected-user').prev().addClass('rating__person_prev-selected-user');
                    if ($('.rating__person_selected-user').length === 1) {
                        $('.rating-table__tbody').stop().animate({
                            scrollTop: $('.rating__person_selected-user').position().top - 62
                        }, 1000);
                    }
                }
            }
        },
        complete: function() {
            setTimeout(function(){
                $('.rating-wrap').parents('.loading').removeClass('visible');
            }, preloaderTime)
        }
    });
}

// Запрос на изменение статуса просмотра блока
function setView(type, link) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'type=' + type + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/set-view/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                link.removeClass('btn-new');
            }
        }
    });
}

// Запрос на попап другого пользователя
function getUserPopup(user_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'id=' + user_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/user-popup/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.body-cover').find('.pop-up-wrapper.person').remove();
                $('.body-cover').append(responseObj.templates.popup);
                showPopUp('person');
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Запрос на попап ответов
function getAnswersPopup(stage_number) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'number=' + stage_number + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/answers-popup/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.body-cover').find('.pop-up-wrapper.answers').remove();
                $('.body-cover').append(responseObj.templates.popup);
                showPopUp('answers');
                sliderInit();
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

function sendFeedback(jqForm) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    trimFormFields(jqForm);

    dataToSend = jqForm.serialize() + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/feedback/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                showLastFeedbackSlide();
                deleteFeedbackOpportunity();
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// Согласие с правилами конкурса
function acceptRules() {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    $.ajax({
        data: dataToSend,
        url: '/api/site/accept-rules/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $("a[href*='#rules']").removeClass('btn-new');
                window.location.href = responseObj.data.url;
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

function startBackTimer() {
    $('.user-pop-up__resend-code-btn').addClass('hidden');
    backTimer();
    $('.user-pop-up__resend-code-timer').removeClass('hidden');
}

function showVerifyPopUp(id, phone) {
    $('.verify-phone').data('account-id', id);
    $('.verify-phone').data('account-phone', phone);
    $('.user-pop-up__phone-place').text(phone)
    startBackTimer();
    showPopUp('verify-phone');
}

function fillSelect(select, data) {
    var selectOption = $('<div/>', {
        class: 'select__option',
    });

    $.each(data, function(index, item) {
        selectOption.attr('data-id', item.id);
        selectOption.attr('data-type', item.type);
        selectOption.text(item.name);
        selectOption.clone().appendTo(select);
    });

    if (data.length === 1) {
        select.siblings('.select__value').val(data[0].name);
        select.siblings('.select__value').data('id', data[0].id);

        var id = data[0].id;
        if (select.hasClass('select__options-list_location')) {
            getSchool(id);
            return false;
        }
        else if (select.hasClass('select__options-list_school')) {
            getClasses(id);
            return false;
        }
    }
}

function setStealthMode(user_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'user_id=' + user_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/stealth/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                window.location.reload();
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}
